namespace advisorop.components.advisor {

    class BoxHhFolderController {
        householdId: number;

        selBoxFolder: { name: string, id: string, parentFolderId: string };
        boxFolderPath: { name: string, id: string }[] = [];
        boxSubfolders: { name: string, id: string, parentFolderId: string }[];
        boxFolder: { item1: string, item2: string }; //item1=id, item2=path

        static $inject = [ "generalService", "boxApi"];
        constructor(private generalService: services.GeneralService, private boxApi: services.BoxApi) {
        }

        public get selBoxFolderPath(): string {
            return "/" + (this.boxFolderPath.map(m => m.name).join("/") ?? "/");
        }

        selBoxFolderChanged() {
            //console.log(this.selBoxFolder);
            this.boxFolderPath.push({
                id: this.selBoxFolder.id,
                name: this.selBoxFolder.name,
            });

            this.selBoxFolder = null;

            this.loadBoxSubfolders();
        }

        levelUp() {
            //console.log("LevelUp...");

            if (this.boxFolderPath.length <= 0) {
                //console.log("levelUp not available...");
                return; // root must be there
            }

            this.boxFolderPath.pop();

            this.boxFolderPath = [...this.boxFolderPath];

            this.loadBoxSubfolders();
        }

        setHhFolder() {
            // last folder in the path
            if (this.boxFolderPath.length > 0) {
                const folderId = this.boxFolderPath[this.boxFolderPath.length - 1].id;

                const path = this.boxFolderPath.map(m => m.name).join("/");

                this.boxApi
                    .setBoxHhFolder(folderId, path, this.householdId)
                    .then(resp => {
                        toastr.success("Box folder for household has been set");
                        this.boxFolder = {
                            item1: folderId,
                            item2: path
                        };
                    }, err => this.generalService.showError(err));
            } else {
                toastr.warning("You have not selected a Box location.");
            }
        }

        loadBoxSubfolders() {
            const parentBoxFolder = this.boxFolderPath[this.boxFolderPath.length - 1];

            const parentBoxFolderId = parentBoxFolder == null ? "0" : parentBoxFolder.id;

            this.boxSubfolders = null;

            this.boxApi.getBoxSubfoldersByHH(parentBoxFolderId, this.householdId)
                .then(resp => this.boxSubfolders = resp.data);
                // Do not show the error here, it is possible that Box has not been
                // configured for this firm...
                //, err => this.generalService.showError(err));
        }

        loadHhFolder() {
            this.boxApi
                .getBoxHhFolder(this.householdId)
                .then(resp => {
                    this.boxFolder = resp.data;
                }, err => this.generalService.showError(err));
        }

        $onInit(): void {
        }

        $onChanges(evt): void {
            for(var key in evt) {
                if (key === "householdId") {
                    if (this.householdId && this.householdId > 0) {
                        this.loadBoxSubfolders();
                        this.loadHhFolder();
                    }
                }
            }
        }

        $routerOnActivate(next, previous) {
        }
    }

    class BoxHhFolder implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.controller = BoxHhFolderController;
            this.controllerAs = "vm";
            this.bindings = {
                householdId: "<",
            };
            this.templateUrl = "spa/shared/common/box-hh-folder.html";
        }
    }
    angular.module(Constants.APP).component("boxHhFolder", new BoxHhFolder());
}